import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, PencilRuler } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { tr } from "@/data/i18n";
import { WorkoutView } from "@/components/WorkoutView";

export default function ManualBuilder() {
  const { lang } = useAuth();
  const navigate = useNavigate();
  const [plan, setPlan] = useState({
    id: crypto.randomUUID(),
    title: "",
    goal: "Personalizzata",
    equipment: "",
    level: "Personalizzato",
    source: "manual",
    generation: 1,
    days: [{ name: `${tr(lang, "day")} 1`, focus: "", exercises: [] }],
  });

  return (
    <div>
      <div className="mx-auto max-w-5xl px-4 sm:px-6 pt-8">
        <button onClick={() => navigate("/")} className="mb-4 inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-white">
          <ArrowLeft size={16} /> {tr(lang, "back")}
        </button>
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-zinc-800 text-red-400"><PencilRuler /></div>
          <div>
            <h1 className="font-display text-3xl font-extrabold uppercase text-white">{tr(lang, "mode_manual_title")}</h1>
            <p className="text-sm text-zinc-500">{tr(lang, "mode_manual_desc")}</p>
          </div>
        </div>
      </div>

      <WorkoutView plan={plan} setPlan={setPlan} editable />
    </div>
  );
}
